import { useQuery } from '@tanstack/react-query';

import { type InParkingCard } from 'src/features/cards/types/card';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/cards/in-parking/';

interface DTO extends ListDTO {
    parkingId: string;
    card_number?: string | string[];
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<InParkingCard>> => {
    // Custom core filtering
    Object.entries(params).map(([key, value]) => {
        if (Array.isArray(value)) params[key] = params[key].join(',');
    });

    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_CARDS_IN_PARKING_RESOURCE,
    queryFn as listCardsInParking,
    useQueryHook as useListCardsInParking,
};
export type { DTO as ListCardsInParkingDTO };
